import { useEffect } from "react";
import { useRouter } from "next/router";

import useGlobal from "../../store";
import Helpers from "../../services/helpers";
import Services from "../../services";
import { FAVORITE_TYPES } from "../../globals";

export const FetchFavorites = () => {
  const [, globalActions] = useGlobal();
  const router = useRouter();

  async function fetchFavorites() {
    try {
      const [shallowCards, shallowPlayers, shallowSealedWaxes] = await Promise.all([
        Services.getFavorites(FAVORITE_TYPES.CARD),
        Services.getFavorites(FAVORITE_TYPES.PLAYER),
        Services.getFavorites(FAVORITE_TYPES.SEALED_WAX),
      ]);

      let initialFavorites = [];
      if (shallowCards && shallowCards.length) {
        initialFavorites = initialFavorites.concat(shallowCards);
      }

      if (shallowPlayers && shallowPlayers.length) {
        initialFavorites = initialFavorites.concat(shallowPlayers);
      }

      if (shallowSealedWaxes && shallowSealedWaxes.length) {
        initialFavorites = initialFavorites.concat(shallowSealedWaxes);
      }

      globalActions.setShallowFavorites(initialFavorites);
    } catch (e) {
      console.error(e);
      Helpers.handleApiError(e, router);
    }
  }

  useEffect(() => {
    fetchFavorites();
  }, []);

  return null;
};
